import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function useLocalizedPath() {
  const { lang } = useParams()
  const { i18n } = useTranslation()
  const currentLang = lang || i18n.language
  const hasLangPrefix = !!lang

  const localizedPath = useCallback((path) => {
    if (!path || path.startsWith('http')) return path
    if (!hasLangPrefix) return path
    return `/${currentLang}${path}`
  }, [currentLang, hasLangPrefix])

  return localizedPath
}
